import posthog from 'posthog-js'

if (typeof window !== 'undefined') {
  // checks that we are client-side
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://redirects.surprise-kultour.ch/ingest',
    ui_host: 'https://eu.posthog.com',
    //api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com',
    person_profiles: 'always', // or 'identified_only' to only create profiles for known users (logged-in)
    loaded: (posthog) => {
      // if (process.env.NODE_ENV === 'development') posthog.debug() // debug mode in development
    },
  })
}

export default posthog
